import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { ColumnsBalancer } from '../../../../../components/ColumnsBalancer';
import { PreviewField } from '../../../../../components/PreviewField';
import { useTranslationAPI } from '../../../../translations';
import { codes } from '../../../../../data/translations';
import { isBadOrEmptyString } from '../../../../../predicates/string';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';

export const PublicJobDetailForm: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: {
			jobCategoryFormattedName,
			industryFormattedName,
			workingHoursPerWeekFormatted,
			experienceFormattedName,
			jobEducationLevelName,
			formattedPeriod,
		},
	} = usePublicJobDetailDataQuery();

	return (
		<ColumnsBalancer>
			<PreviewField
				label={translate(codes.common.category)}
				value={jobCategoryFormattedName}
			/>
			<PreviewField
				label={translate(codes.domainValue.industry)}
				value={industryFormattedName}
			/>
			{!isBadOrEmptyString(workingHoursPerWeekFormatted) && (
				<PreviewField
					label={translate(jobModuleCodes.workingHoursPerWeek)}
					value={workingHoursPerWeekFormatted}
				/>
			)}
			<PreviewField
				label={translate(codes.domainValue.experienceLevel)}
				value={experienceFormattedName}
			/>
			<PreviewField
				label={translate(codes.domainValue.educationLevel)}
				value={jobEducationLevelName}
			/>
			{!isBadOrEmptyString(formattedPeriod) && (
				<PreviewField
					label={translate(jobModuleCodes.workingPeriod)}
					value={formattedPeriod}
				/>
			)}
		</ColumnsBalancer>
	);
};
